import React, { useState } from 'react';
import { Container } from '../ui/Container';
import { useIsMobile } from '../../Hooks/useIsMobile';
import { Button } from '../ui/Button';
import { useBrand } from '../../Utils/BrandContext';

const FAQSection = ({ onFAQToggle, onBuyNow }) => {

  const isMobile = useIsMobile();
  const { brand: activeBrand } = useBrand()

  // Changed to an array to support multiple open items
  const [openIndices, setOpenIndices] = useState([]);

  // FAQ data split into two columns for desktop
  const leftColumnFaqs = [
    {
      question: 'Can I access from <b>Mobile</b> and <b>Desktop</b>?',
      answer: 'Yes of course! You can also use our beta Android App from Play Store. Our iOS app will be launched soon. Each user can access from desktop or mobile browser, as well as mobile app.'
    },
    {
      question: `Can <b>Service Providers</b> use ${activeBrand === 'bz' ? 'Biziverse' : 'QikERP'} ERP?`,
      answer: `<b>Yes totally!</b> You can manage your <b>Service Orders</b> and <b>Support Tickets</b>, and Delight your Customers by taking Timely Action by smartifing your operations with ${activeBrand === 'bz' ? 'Biziverse' : 'QikERP'}. You can even <b>manage your Stock of important materials or spares</b>, and <b>import and track Lead Conversion using CRM</b>.`
    },
    {
      question: `Can <b>Traders</b> or <b>Wholesellers</b> or <b>Exporters</b> use ${activeBrand === 'bz' ? 'Biziverse' : 'QikERP'}?`,
      answer: 'Your growth requires anytime access and quick management of <b>Quotations, Billing, Purchase Orders,</b> and <b>Inventory</b>. You can manage <b>Import Purchases</b> as well as <b>Export Invoice generation,</b> or <b>create e-Invoices using Biziverse Accounts</b>.'
    },
    /*{
      question: 'Can I get a <b>trial</b> access?',
      answer: 'Even better than that! While we do not offer trial, we offer a <b>100% moneyback guarantee</b> for up to 3 days from your purchase of the Starter edition subscription.'
    },*/
    {
      question: 'How can I <b>start</b> using Biziverse?',
      answer: 'Once you start your subscription, you can access our vast Help materials (Videos and Tutorials), as well as attend our LIVE Training sessions every weekday. You can also import your leads using our Excel templates, and set up user accounts for your team members.'
    },
    {
      question: `Why is ${activeBrand === 'bz' ? 'Biziverse' : 'QikERP'} <b>priced so low</b>?`,
      answer: 'Our mission is to help Indian MSMEs become globally competitive. We want every MSME to use smart software. Server hosting cost is now hardly ₹ 50 per customer per year, due to our volume model. Our 15+ years of experience in ERP & CRM helped us optimize support processes to further reduce cost, while improving customer experience.'
    },
    {
      question: 'How can I <b>migrate / transfer</b> my data from my current software?',
      answer: 'You can easily import your Leads, Customers, Suppliers, Inventory items using our Excel templates. Additionally, you can also import your accounting Ledgers, with a snapshot of their final balances via our Excel template.'
    }
  ];

  const rightColumnFaqs = [
    {
      question: 'How can I get <b>Training</b> and <b>Support</b>?',
      answer: 'Training is given every weekday. So your team can learn and re-learn. You will also find Help materials (Videos and Tutorials) linked on every page, or click Need Help ("?") to raise a ticket, so our team can reach you asap! Our support team is accessible everyday, even on Sundays!'
    },
    {
      question: 'Can <b>Retail Shops</b> benefit from Biziverse?',
      answer: '<b>Of course yes!</b> You can quickly generate <b>POS Invoices with Barcode facility</b> for your <b>retail customers, monitor Inventory and keep Sufficient Stock, and manage your Purchase Order to Suppliers</b>. You can handle <b>Accounts</b> and <b>Inventory of a single or multiple outlets easily!</b>.'
    },
    {
      question: 'Can <b>Manufacturers</b> simplify management with Biziverse?',
      answer: '<b>Absolutely yes!</b> Smart manufacturers must keep <b>Sufficient Stock of Raw Materials</b>, and <b>monitor Consumption against Bill of Materials (BOM)</b> and <b>Production Work in Process (WIP)</b>. Biziverse thus helps you deliver Orders in time and increase <b>Repeat Business</b>, while also simplifying other operations like <b>Accounts, Tasks, Purchase,</b> and <b>Lead Conversion (CRM)</b>.'
    },
    {
      question: `Is ${activeBrand === 'bz' ? 'Biziverse' : 'QikERP'} <b>right</b> for my business?`,
      answer: `${activeBrand === 'bz' ? 'Biziverse' : 'QikERP'} is ideal for micro and small enterprises. While our customer base encompasses companies ranging from just one individual to NSE-listed large corporations, we have found that the maximum benefit is derived by smaller scale enterprises, as they are closely managed by smart entrepreneurs, and seek to grow fast with technology transformation.`
    },
    {
      question: `Where is ${activeBrand === 'bz' ? 'Biziverse' : 'QikERP'} <b>hosted</b>?`,
      answer: 'Biziverse platform and services are hosted on a powerful cloud server of E2E Networks Ltd., an NSE-listed company based in NCR. Their customers include several reputed brands such as Zomato, Jabong, CarDekho. We selected E2E Networks after a thorough review and comparison, and are impressed with their practices and promptness of service!'
    },
    {
      question: 'Can I get a <b>Demo</b>?',
answer: 'Absolutely! Please watch <b style="text-decoration:underline;cursor:pointer" onclick="event.stopPropagation(); if(window.innerWidth<768){(function(){var el=document.getElementById(\'demoSection\');if(el){window.scrollTo({top:el.offsetTop-70,behavior:\'smooth\'});}})()}else{window.open(\'https://qikerp.com/QikERP/Videos/QikERP_IntroV.mp4\',\'_blank\')}">our intro video</b>, or browse <b style="text-decoration:underline;cursor:pointer" onclick="event.stopPropagation(); if(window.innerWidth<768){(function(){var el=document.getElementById(\'demoSection\');if(el){window.scrollTo({top:el.offsetTop-70,behavior:\'smooth\'});}})()}else{window.open(\'https://qikerp.com/QikERP/pdfs/QikERP%20Demo%20Intro.pdf\',\'_blank\')}">demo screens here</b>.'     
 // answer: 'Absolutely! Please click <b style="text-decoration:underline;cursor:pointer" onclick="event.stopPropagation(); if(window.innerWidth<768){window.selectDemoLang && window.selectDemoLang(\'hindi\')}else{window.open(\'https://qikerp.com/QikERP/Videos/QikERP_IntroV.mp4\',\'_blank\')}">this link for our Hindi demo</b>, and <b style="text-decoration:underline;cursor:pointer" onclick="event.stopPropagation(); if(window.innerWidth<768){window.selectDemoLang && window.selectDemoLang(\'english\')}else{window.open(\'https://qikerp.com/QikERP/Videos/Biziverse_DemoVO.mp4\',\'_blank\')}">this link for the English demo</b>. You can also browse <b style="text-decoration:underline;cursor:pointer" onclick="event.stopPropagation(); if(window.innerWidth<768){(function(){var el=document.getElementById(\'demoSection\');if(el){window.scrollTo({top:el.offsetTop-70,behavior:\'smooth\'});}})()}else{window.open(\'https://qikerp.com/QikERP/pdfs/QikERP%20Demo%20Intro.pdf\',\'_blank\')}">screens at this link</b>.'
    }
  ];

  // Combined FAQs for mobile
  const allFaqs = [
    ...leftColumnFaqs.slice(0, 1),
    ...rightColumnFaqs.slice(0, 1),
    ...leftColumnFaqs.slice(1, 2),
    ...rightColumnFaqs.slice(1, 2),
    ...leftColumnFaqs.slice(2, 3),
    ...rightColumnFaqs.slice(2, 3),
    ...leftColumnFaqs.slice(3, 4),
    ...rightColumnFaqs.slice(3, 4),
    ...leftColumnFaqs.slice(4, 5),
    ...rightColumnFaqs.slice(4, 5),
    ...leftColumnFaqs.slice(5, 6),
    ...rightColumnFaqs.slice(5, 6),
    ...leftColumnFaqs.slice(6, 7)
  ];

  const toggleFAQ = (index, question) => {
    if (onFAQToggle) onFAQToggle(question);
    if (isMobile) {
      // Mobile behavior: keep your existing accordion logic (one at a time)
      setOpenIndices(prev => prev.includes(index) ? [] : [index]);
    } else {
      // Desktop behavior: toggle multiple items independently
      setOpenIndices(prev =>
        prev.includes(index)
          ? prev.filter(i => i !== index)
          : [...prev, index]
      );
    }
  };

  // Mobile Layout
  if (isMobile) {
    return (
      <section id="faqSection" className="bg-white border-top py-12 md:py-16 lg:py-20 border-top">
        <Container>
          {/* Header */}
          <div className="text-center mb-10">
            <h2 className="text-[30px] md:text-[40px] font-bold secttl mb-3">
              Frequently Asked Questions
            </h2>
            <p className="text-[14px] md:text-lg text-text-primary">
              Click to know more
            </p>
          </div>

          {/* FAQ Items */}
          <div className="max-w-3xl mx-auto space-y-3">
            {allFaqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-light border border-border rounded overflow-hidden"
              >
                {/* Question */}
                <a
                  onClick={() => toggleFAQ(index, faq.question.replace(/<[^>]+>/g, ''))}
                  className="w-full px-3 md:px-6 py-4 flex justify-between items-center text-left hover:bg-gray-50 transition-colors"
                >
                  <h3
                    className="text-[14px] md:text-lg text-text-primary md:font-semibold  pr-4"
                    dangerouslySetInnerHTML={{ __html: faq.question }}
                  />
                  <span className="text-primary flex-shrink-0">
                    {/* Use includes(index) because state is now an array */}
                    {openIndices.includes(index) ? (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </span>
                </a>

                {/* Answer */}
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${openIndices.includes(index) ? 'max-h-96' : 'max-h-0'
                    }`}
                >
                  <div className="px-5 md:px-6 pb-4">
                    <p
                      className="text-sm md:text-base text-text-secondary leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Buy Now Button - Mobile only, after FAQs */}
          <div className="mt-10 mb-4 text-center mx-11">
            <Button
              onClick={onBuyNow}
              className="mobile-btn"
            >
              Buy Now
            </Button>
          </div>

        </Container>
      </section>
    );
  }

  // Desktop Layout
  return (
    <section id="faqSection" className="bg-white border-top border-gray-300 py-12 md:py-16 lg:py-20">
      <Container variant="wide">
        {/* Header */}
        <div className="text-center mb-12">
          <h1
            className="m-0 text-[40px] font-bold secttl mb-12"
          >
            Frequently Asked Questions
          </h1>
        </div>

        {/* Two Column Layout */}
        <div className="flex">
          {/* Left Column */}
          <div className="w-1/2 pl-[10%]">
            {leftColumnFaqs.map((faq, index) => {
              const faqIndex = `left-${index}`;
              const isOpen = openIndices.includes(faqIndex);

              return (
                <div
                  key={faqIndex}
                  className="w-[91.67%] mb-4 inline-block mr-10"
                  style={{ boxShadow: 'none' }}
                >
                  {/* Question Header */}
                  <div className="flex justify-between items-start">
                    <a
                      onClick={() => toggleFAQ(faqIndex, faq.question.replace(/<[^>]+>/g, ''))}
                      className="text-left no-underline text-[#333] text-base pt-[10px] pb-0 pl-[20px] pr-0 w-full flex items-start cursor-pointer"
                    >
                      <span className="text-primary mr-3 mt-1 flex-shrink-0">
                        {isOpen ? (
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                          </svg>
                        ) : (
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        )}
                      </span>
                      <span
                        className="text-black"
                        dangerouslySetInnerHTML={{ __html: faq.question }}
                      />
                    </a>
                  </div>

                  {/* Answer */}
                  {isOpen && (
                    <div>
                      <a
                        onClick={() => toggleFAQ(faqIndex)}
                        className="text-left no-underline text-[#333] text-[14px] pt-[15px] pb-0 pl-[20px] pr-0 w-full cursor-pointer"
                      >
                        <div
                          className="py-0 pb-[15px] pl-[20px]"
                          style={{ lineHeight: '1.6' }}
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      </a>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Right Column */}
          <div className="w-1/2 pl-[10%]">
            {rightColumnFaqs.map((faq, index) => {
              const faqIndex = `right-${index}`;
              const isOpen = openIndices.includes(faqIndex);

              return (
                <div
                  key={faqIndex}
                  className="w-[91.67%] mb-4 inline-block"
                  style={{ boxShadow: 'none' }}
                >
                  {/* Question Header */}
                  <div className="flex justify-between items-start">
                    <a
                      onClick={() => toggleFAQ(faqIndex, faq.question.replace(/<[^>]+>/g, ''))}
                      className="text-left no-underline text-[#333] text-base pt-[10px] pb-0 pl-[20px] pr-0 w-full flex items-start cursor-pointer"
                    >
                      <span className="text-primary mr-3 mt-1 flex-shrink-0">
                        {isOpen ? (
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                          </svg>
                        ) : (
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        )}
                      </span>
                      <span
                        className="text-black"
                        dangerouslySetInnerHTML={{ __html: faq.question }}
                      />
                    </a>
                  </div>

                  {/* Answer */}
                  {isOpen && (
                    <div>
                      <a
                        onClick={() => toggleFAQ(faqIndex)}
                        className="text-left no-underline text-[#333] text-[14px] pt-[15px] pb-0 pl-[20px] pr-0 w-full cursor-pointer"
                      >
                        <div
                          className="py-0  pb-[15px] pl-[20px]"
                          style={{ lineHeight: '1.6' }}
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      </a>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FAQSection;